import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.scss';
import { ThemeProvider } from '@mui/material/styles';
import Header from './components/layout/Header';
import PageMessage from './components/layout/PageMessage';
import Theme from './styles/Theme';
import UserContext from './context/UserContext';
import PrivateRoute from './components/route/PrivateRoute';
import Dashboard from './components/dashboard/Dashboard';
import Login from './components/authentication/Login';
import CacheClear from './components/content/CacheClear';
import ManageMarketingTags from './components/content/ManageMarketingTags';
import CourseMaps from './components/course/maps/CourseMaps';
import CourseRegistration from './components/course/registration/CourseRegistration';
import StudentTranscript from './components/course/transcript/StudentTranscript';
import MagdalaRegistration from './components/magdala/MagdalaRegistration';
import CommunityRegistration from './components/magdala/CommunityRegistration';
import ManageCommunity from './components/magdala/ManageCommunity';
import ManageMember from './components/member/ManageMember';
import MemberRegistration from './components/member/MemberRegistration';
import ManageEmailCategories from './components/notifications/ManageEmailCategories';
import SendNotification from './components/notifications/SendNotification';
import DownloadReport from './components/reports/DownloadReport';
import ReportSelection from './components/reports/ReportSelection';
import CourseProgressReport from './components/reports/course/CourseProgressReport';
import StudentTranscriptReport from './components/reports/course/StudentTranscriptReport';
import WatchlistManager from "./components/zoomboard/WatchlistManager";
import LiveBoard from "./components/zoomboard/LiveBoard";
import Monitor from './components/Monitor';
import NotFound from './components/NotFound';
import urls from './config/urls';


class App extends Component {
  render() {
    return (
      <div className="App">
        <UserContext.Provider value={this.props.user}>
          <ThemeProvider theme={Theme}>
            <Header />
            <div id="HeaderOffset"></div>
            <PageMessage />
            <main>
              <Routes>
                <Route path={urls.root} element={<Navigate to={urls.login} replace />} />
                <Route path={urls.login} element={<Login />} />
                <Route path={urls.dashboard} element={<PrivateRoute component={Dashboard} />} />
                {/* Course */}
                <Route path={urls.courseMaps} element={<PrivateRoute component={CourseMaps} />} />
                <Route path={urls.courseRegistration} element={<PrivateRoute component={CourseRegistration} />} />
                <Route path={urls.studentTranscript} element={<PrivateRoute component={StudentTranscript} />} />
                {/* Magdala */}
                <Route path={urls.magdalaRegistration} element={<PrivateRoute component={MagdalaRegistration} />} />
                <Route path={urls.magdalaCommunityRegistration} element={<PrivateRoute component={CommunityRegistration} />} />
                <Route path={urls.magdalaCommunityManage} element={<PrivateRoute component={ManageCommunity} />} />
                {/* Member */}
                <Route path={urls.memberManage} element={<PrivateRoute component={ManageMember} />} />
                <Route path={urls.memberRegistration} element={<PrivateRoute component={MemberRegistration} />} />
                {/* Content Management */}
                <Route path={urls.cacheClear} element={<PrivateRoute component={CacheClear} />} />
                <Route path={urls.manageMarketingTags} element={<PrivateRoute component={ManageMarketingTags} />} />
                {/* Notifications */}
                <Route path={urls.manageEmailCategories} element={<PrivateRoute component={ManageEmailCategories} />} />
                <Route path={urls.sendNotifications} element={<PrivateRoute component={SendNotification} />} />
                {/* Reports */}
                <Route path={urls.reportDownload} element={<PrivateRoute component={DownloadReport} />} />
                <Route path={urls.courseReports} element={<PrivateRoute component={ReportSelection} />} />
                <Route path={urls.courseProgressReport} element={<PrivateRoute component={CourseProgressReport} />} />
                <Route path={urls.courseTranscriptReport} element={<PrivateRoute component={StudentTranscriptReport} />} />
                {/* Zoomboard */ }
                <Route path={urls.watchlistManager} element={<PrivateRoute component={WatchlistManager} />} />
                <Route path={urls.liveBoard} element={<PrivateRoute component={LiveBoard} />} />
                {/* Open - for monitoring availability */}
                <Route path={urls.monitor} element={<Monitor />} />
                {/* Fallback */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
          </ThemeProvider>
        </UserContext.Provider>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { 
    user: state.user
  };
}

export default connect(mapStateToProps)(App);
